<template>
  <div class="main-wrapper">
    <roe-wizard-header title="View Report" :num="4"></roe-wizard-header>

    <div class="content">
      <div class="scrollable-content">
        <div class="scrollable-content--width">
          <div class="final-report-grid">
            <div class="section-wrap">
              <section>
                <div class="section-header">
                  <h2>Preview</h2>
                </div>
                <div class="section-content">
                  <div class="preview-wrap">
                    <img
                      src="@/assets/ico/ico-report-watermark.svg"
                      alt="report with watermark"
                    />
                    <button class="btn-primary" @click="downloadPreview">
                      <roe-three-dots-animation v-if="reportPreviewDownloading"
                        >Downloading</roe-three-dots-animation
                      >
                      <span v-else>Download Preview</span>
                    </button>
                  </div>
                </div>
              </section>
            </div>
            <div class="section-wrap">
              <section>
                <div class="section-header">
                  <h2>Final Report</h2>
                </div>
                <div class="section-content">
                  <div class="final-report-content-wrap">
                    <div class="report-preview-img">
                      <img
                        src="@/assets/ico/ico-report.svg"
                        alt="final report"
                      />
                    </div>
                    <div class="report-preview-content">
                      <div class="textarea-label-wrap">
                        <div class="textarea-label">
                          Contact information<br />
                          (will appear on the cover page of the report)
                        </div>
<!--                        <div class="textarea-sub-label">-->
<!--                          {{ charactersLeft }} characters left-->
<!--                        </div>-->
                      </div>
                      <roe-error-message :field="$v.contact_info">
                        <textarea v-model="contact_info"></textarea>
                      </roe-error-message>
                    </div>
                  </div>
                  <div class="final-report-btn-wrap">
                    <button class="btn-primary" @click="downloadFinal">
                      <roe-three-dots-animation v-if="finalReportDownloading"
                        >Downloading</roe-three-dots-animation
                      >
                      <span v-else>Download Final Report</span>
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  REPORT_FINAL_DOWNLOAD,
  REPORT_PREVIEW_DOWNLOAD
} from "@/store/actions.type";
import RoeWizardHeader from "@/components/layouts/WizardHeader";
import RoeThreeDotsAnimation from "@/components/_shared/ThreeDotsAnimation";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import { SHOW_FORM_ERRORS } from "@/store/mutations.type";
export default {
  components: { RoeErrorMessage, RoeThreeDotsAnimation, RoeWizardHeader },
  mixins: [validationMixin],
  computed: {
    ...mapGetters([
      "finalReportDownloading",
      "reportPreviewDownloading",
      "invalidForm",
      "reportContactInfo"
    ]),
    charactersLeft() {
      let number = 70 - this.contact_info.length;
      return number < 0 ? 0 : number;
    }
  },
  data() {
    return {
      contact_info: ""
    };
  },
  created() {
    this.contact_info = this.reportContactInfo;
  },
  validations() {
    return {
      contact_info: { required }
    };
  },
  methods: {
    downloadFinal() {
      if (this.isValid()) {
        this.$store.dispatch(REPORT_FINAL_DOWNLOAD, {
          id: this.$router.currentRoute.params.id,
          contact_info: this.contact_info
        });
      }
    },
    downloadPreview() {
      if (this.isValid()) {
        this.$store.dispatch(REPORT_PREVIEW_DOWNLOAD, {
          id: this.$router.currentRoute.params.id,
          contact_info: this.contact_info
        });
      }
    },
    isValid() {
      if (this.$v.$invalid) {
        this.$store.commit(SHOW_FORM_ERRORS);
        this.flashMessage.error({
          title: "Error",
          message: "Contact info contains errors"
        });
        return false;
      }
      return true;
    }
  }
};
</script>
